"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RetailerOption = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = require("react");

var _Avatar = require("../Avatar");

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

var RetailerOption = function RetailerOption(_ref) {
  var retailer = _ref.retailer,
      _ref$services = _ref.services,
      services = _ref$services === void 0 ? {} : _ref$services;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      service = _useState2[0],
      setService = _useState2[1];

  (0, _react.useEffect)(function () {
    if (services[retailer.id]) {
      setService(Object.keys(services[retailer.id]));
    }
  }, [services]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "avatar-and-retailer",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
        image: "https://content-management-images.s3.amazonaws.com/retailers/".concat(retailer.id, ".png"),
        altText: retailer === null || retailer === void 0 ? void 0 : retailer.name,
        imageType: "medium-image"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "retailer-name",
        children: retailer === null || retailer === void 0 ? void 0 : retailer.name
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "services-icons",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "material-icons small ".concat(service.includes("datasheet") && "is-active"),
        children: "\uF8EE"
      }, "datasheet"), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "material-icons small ".concat(service.includes("description") && "is-active"),
        children: "\uE873"
      }, "description"), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "material-icons small ".concat(service.includes("images") && "is-active"),
        children: "\uE3F4"
      }, "images")]
    })]
  });
};

exports.RetailerOption = RetailerOption;